import { render, staticRenderFns } from "./AddGroupUser.vue?vue&type=template&id=d6b23ac4"
import script from "./AddGroupUser.vue?vue&type=script&lang=js"
export * from "./AddGroupUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports